import script from "./ContinuosFlowStep2View.vue?vue&type=script&setup=true&lang=js"
export * from "./ContinuosFlowStep2View.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__